const languages = require('utils/Language.js')

const {Notyf} = require("notyf");


/*
 * ============================================================
 * DISPLAY MODE
 * ============================================================
 *
 * Por defecto:
 * - Móvil  -> versión móvil
 * - Tablet -> versión móvil
 * - PC     -> versión móvil
 *
 * Para forzar la versión escritorio:
 *
 * ?desktop=1
 *
 * Ejemplo:
 * https://seye.tech/dashboard/plants/thermal?desktop=1
 *
 * ============================================================
 */

const params = new URLSearchParams(
    window.location.search
);

const forceDesktop =
    params.get("desktop") === "1";


module.exports = global.config = {

    languages:
        languages.getPermittedLanguages(),

    brand_url:
        'img/seye.svg',

    api_url_v1:
        'https://' +
        process.env.REACT_APP_API_ENDPOINT +
        '/api/v1/',

    notyf_object:
        new Notyf({

            position: {
                x: 'center',
                y: 'top'
            }

        }),

    notyf_object_dash:
        new Notyf({

            position: {
                x: 'right',
                y: 'bottom'
            }

        }),


    /*
     * ========================================================
     * MOBILE / DESKTOP VERSION
     * ========================================================
     */

    mbl_version: !forceDesktop

};